import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/reset.css";
import TwingeApp from "./App";
import { store } from "./redux-toolkit/store/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <TwingeApp />
  </Provider>
);

reportWebVitals();
